interface NavItem {
  title: string;
  href: string;
  description?: string;
  children?: NavItem[];
}

export const siteConfig = {
  name: "2Solutions",
  description: "AI-powered solutions for Amazon sellers to optimize and grow their business.",
  mainNav: [
    {
      title: "Home",
      href: "/",
    },
    {
      title: "2SOLV Token",
      href: "https://token.2solutions.co",
    },
    {
      title: "Exchange",
      href: "https://exchange.2solutions.co",
    },
    {
      title: "Wallet",
      href: "https://wallet.2solutions.co",
    },
    {
      title: "How It Works",
      href: "/how-it-works",
    },
    {
      title: "Pricing",
      href: "/pricing",
    },
    {
      title: "About",
      href: "/about",
    },
    {
      title: "Testimonials",
      href: "/testimonials",
    },
    {
      title: "Contact",
      href: "/contact",
    },
  ] as NavItem[],
  footerNav: [
    {
      title: "Company",
      children: [
        { title: "About Us", href: "/about" },
        { title: "Careers", href: "/careers" },
        { title: "Press", href: "/press" },
        { title: "Blog", href: "/blog" },
      ],
    },
    {
      title: "Product",
      children: [
        { title: "Features", href: "/#features" },
        { title: "Pricing", href: "/pricing" },
        { title: "Testimonials", href: "/testimonials" },
        { title: "FAQ", href: "/faq" },
      ],
    },
    {
      title: "Support",
      children: [
        { title: "Help Center", href: "/help" },
        { title: "Contact Us", href: "/contact" },
        { title: "API Status", href: "/status" },
        { title: "Documentation", href: "/docs" },
      ],
    },
    {
      title: "Legal",
      children: [
        { title: "Privacy Policy", href: "/privacy" },
        { title: "Terms of Service", href: "/terms" },
        { title: "Cookie Policy", href: "/cookies" },
        { title: "GDPR", href: "/gdpr" },
      ],
    },
  ] as NavItem[],
  socialLinks: {
    twitter: "https://twitter.com/2solutions",
    facebook: "https://facebook.com/2solutions",
    linkedin: "https://linkedin.com/company/2solutions",
    instagram: "https://instagram.com/2solutions",
  },
}
